module.exports = __webpack_public_path__ + "img/Desktop-screenshot-p-1080.d38048f1.png";